
import { Vue, Component, Prop } from "vue-property-decorator";

import Card from "@/components/card/Card.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import TableIcon from "@/components/table/table-icon.vue";
import Processing from "@/components/common/Processing.vue";
import Chip from "@/components/filters/Chip.vue";
import CollapsibleDescription from "@/components/common/CollapsibleDescriptionNew.vue";
import LeftSideWideCard from "@/components/common/LeftSideWideCardNew.vue";
import { Industry, User_Skill } from "@/generated/graphql";
import { getSkillsForChips } from "@/helpers/cardInfoHelperFunctions/chipDataHelpers";
import ItemChipsData from "@/entities/ItemChipsData";
import DotIcon from "@/components/icons/DotIcon.vue";

@Component({
  components: {
    Card,
    CardBodyItem,
    TableIcon,
    Processing,
    Chip,
    CollapsibleDescription,
    LeftSideWideCard,
    DotIcon,
  },
})
export default class ExperienceCard extends Vue {
  @Prop({ type: Array, required: true }) readonly skills!: User_Skill[];
  @Prop({ type: String, required: true }) readonly jobTitle!: string;
  @Prop({ type: String, required: true }) readonly companyName!: string;
  @Prop({ type: String, required: true }) readonly location!: string;
  @Prop({ type: Object, default: () => {} }) readonly industry!: Industry;
  @Prop({ type: String, default: undefined }) readonly summary?: string;
  @Prop({ type: String, default: undefined }) readonly employmentType?: string;
  @Prop({ type: String, default: undefined }) readonly startDate?: string;
     @Prop({ type: String, default: undefined }) readonly isAddedBy?: string;
  @Prop({ type: String, default: undefined }) readonly endDate?: string;

  get industryName(): string | undefined {
    return this.industry?.name;
  }

  get isSkillsExist(): boolean {
    return this.skills.length > 0;
  }

  get experienceSkills(): ItemChipsData[] {
    const skills = this.skills.map((container) => container.skill);
    return getSkillsForChips(skills);
  }

  get formattedStartDate() {
    return this.formatDate(this.startDate);
  }

get getBorder(): Object {
  return{
  "borderBlue": !this.isAddedBy,
  "borderGreen": this.isAddedBy,
  }
}

  get formattedEndDate() {
    return this.formatDate(this.endDate);
  }

  formatDate(dateString: string | undefined) {
    if (!dateString) {
      return "";
    }

    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }
}
